import { http } from '@/utils/plugins/http'
export const getProduct = (id) => http.get(`products/${id}`)
export const updateProduct = ({ id, payload }) => http.put(`/products/${id}`, payload)
export const saveProduct = (payload) => http.post('/products', payload)
export const syncProductWithCA = (id) => http.post(`/products/${id}/sync_product_with_ca`)